<template>
<div class="PageSearch">
    <!-- <van-row type="flex" justify="space-between">
        <van-col :span="searchlefticon !='' ? 3 : 1">
            <van-icon :name="searchlefticon" size=".59rem" style="width:.59rem; height:.63rem; margin:.12rem .35rem 0 .5rem;" @click="clicksearchleft" />
        </van-col>
        <van-col :span="searchlefticon !='' && searchrighticon != '' ? 17 : searchlefticon !=''|| searchrighticon != '' ? 20 : 22">
            <van-cell-group :class="fieldClass">
                <van-field v-model="search_value" :readonly="readonly" :placeholder="placeholder" @click-right-icon="onSearch" @focus="showFullScreenSearchPage">
                    <van-icon slot="right-icon" :name="righticon" />
                </van-field>
            </van-cell-group>
        </van-col>
        <van-col v-if="searchrighticon != ''" :span="3">
            <van-icon :name="searchrighticon" size=".55rem" style="width:.55rem; height:.55rem; margin:.12rem .6rem 0 .35rem;" @click="clicksearchright" />
        </van-col>
    </van-row> -->
    <van-row type="flex" justify="space-start">
        <van-col v-if="searchlefticon" class="left_col">
            <van-icon :name="searchlefticon" size=".59rem" style="width:.59rem; height:.63rem; margin:.12rem .35rem 0 .5rem;" @click="clicksearchleft" />
        </van-col>
        <van-col :class="searchlefticon ? 'search_col': searchrighticon ? 'search_col_big': 'search_col_big_rise'">
            <van-cell-group :class="fieldClass">
                <van-field v-model="search_value" :readonly="readonly" :placeholder="placeholder" @click-right-icon="onSearch" @focus="showFullScreenSearchPage">
                    <van-icon slot="right-icon" :name="righticon" />
                </van-field>
            </van-cell-group>
        </van-col>
        <van-col v-if="searchrighticon != ''" class="right_col">
            <van-icon :name="searchrighticon" size=".55rem" style="width:.55rem; height:.55rem; margin:.12rem .6rem 0 .35rem;" @click="clicksearchright" />
        </van-col>
    </van-row>
</div>
</template>

<script>
import Vue from 'vue';
import Bridge from '../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    name: 'PageSearch',
    data() {
        return {
            search_value: '', // 搜索内容
            FullScreenSearchPageStatus: false, // 全屏搜索面板状态
        }
    },
    props: {
        placeholder: {
            type: String,
            default: function () {
                return "搜索...";
            }
        },
        fieldClass: {
            type: String,
            default: function () {
                return "";
            }
        },
        righticon: {
            type: String,
            default: function () {
                return '';
            }
        },
        readonly: {
            type: Boolean,
            default: function () {
                return true; // true的时候弹出全屏搜索面板，false为输入框搜索
            }
        },
        searchrighticon: {
            type: String,
            default: function () {
                return '';
            }
        },
        searchlefticon: {
            type: String,
            default: function () {
                return '';
            }
        }
    },
    watch: {
        placeholder(curVal, oldVal) { // 提示信息
            if (curVal) {
                this.placeholder = curVal;
            }
        },
        fieldClass(curVal, oldVal) { // 输入框样式
            if (curVal) {
                this.fieldClass = curVal;
            }
        },
        righticon(curVal, oldVal) { // 搜索框右侧icon
            if (curVal) {
                this.righticon = curVal;
            }
        },
        readonly(curVal, oldVal) { // 搜索只读
            if (curVal) {
                this.readonly = curVal;
            }
        },
        searchrighticon(curVal, oldVal) { // 搜索框外右侧icon
            if (curVal) {
                this.searchrighticon = curVal;
            }
        },
        searchlefticon(curVal, oldVal) { // 搜索框外左侧icon
            if (curVal) {
                this.searchlefticon = curVal;
            }
        },
    },
    methods: {
        // 执行搜索
        onSearch() {
            console.log(this.search_value)
            return;
        },
        // 展开全屏搜索面板
        showFullScreenSearchPage() {
			console.log(this.readonly)
			console.log('this.active_page',this.$route.name)
            // 如果搜索框是只读，弹出全屏搜索面板
            if (this.readonly) {
                // this.FullScreenSearchPageStatus = true;
                // 跳转到搜索页面
                if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                    var params = {
                        'data': {
                            'url': this.$publicData.clientUrl + '/search/index'
                        }
                    }
                    this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                    })
                } else {
                    this.$router.push({
                        path: '/search/index',
                        query: {
                            routeName: this.$route.name
                        }
                    })
                }
                
            }
        },
        // 点搜索框外左边ico
        clicksearchleft() {
            console.log('点了左边的ico')
            this.active_page = this.$route.path;
            console.log(this.active_page)
            if (this.active_page === "/shop/index" || this.active_page === "/shop/btob") {
                if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                    var params = {
                        'data': {
                            'url': this.$publicData.clientUrl + '/art/index'
                        }
                    }
                    this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                    })
                } else {
                    this.$router.push({
                        name: 'art-index'
                    })
                }
            }
        },
        // 点搜索框外右边ico
        clicksearchright() {
            console.log('点了右边的ico')
            this.active_page = this.$route.path;
            console.log(this.active_page)
            if (this.active_page === "/shop/index" || this.active_page === "/shop/btob" || this.active_page === "/") {
                if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                    //获取用户信息
                    var memberParams = {
                        'data': {}
                    }
                    console.log('sdjy://member/memberInfo')
                    this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                        if (data.code == 200) {
                            var params = {
                                'data': {
                                    'url': this.$publicData.clientUrl + '/shop/cart'
                                }
                            }
                            this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                            })
                        }
                    })
                    
                } else {
                    this.$router.push({
                        name: 'shop-cart'
                    })
                }
            }
        },
    },
}
</script>

<!-- 
    备注：
    本搜索组件 输入框直接搜索方式未开发；后续可在判断时直接扩展!!!!
 -->
 <!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
